<script>
    export default {
        name: "key-meta",
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            }
        },
        computed: {
            isWizard(){
                if (!(this.rowData.wizards instanceof Object)) {
                    return false
                }

                return Object.keys(this.rowData.wizards).length > 0
            },
            wizardTitle(){
                if(!this.isWizard){
                    return
                }

                return this.$t('lang.main.table.is_wizard') + ": " + Object.values(this.rowData.wizards).join(", ");
            }
        }
    }
</script>

<template>
    <div>
        <span v-if="rowData.isgeo" v-tooltip.left="$t('lang.main.table.is_geo')"><i class="fa fa-globe ks-icons" aria-hidden="true"></i></span>
        <span v-if="rowData.isquest" v-tooltip.left="$t('lang.main.table.is_quest')"><i class="fa fa-question-circle-o ks-icons" aria-hidden="true"></i></span>

        <span v-if="isWizard" v-tooltip.left="wizardTitle"><i class="fa fa-magic ks-icons" aria-hidden="true"></i></span>

    </div>
</template>


<style scoped>
    span:first-child > i{
        padding-left: 0;
    }
</style>
